import { Typography, type TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: "#00ce8e",
  whiteSpace: "normal",

  svg: {
    verticalAlign: "top",
  },

  [theme.breakpoints.down("md")]: {
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    maxWidth: "100%",

    svg: {
      flexShrink: 0,
      verticalAlign: "middle",
    },
  },

  [theme.breakpoints.down(575)]: {
    fontSize: "10px",
  },
}));
